import { jsx as i } from "react/jsx-runtime";
import p from "../DialogBase/DialogBase.js";
const D = ({
  children: o,
  open: t,
  onClose: r,
  dataTestid: s,
  hideAppBar: a,
  className: e
}) => /* @__PURE__ */ i(
  p,
  {
    open: t,
    onClose: r,
    dataTestid: s,
    hideAppBar: a,
    className: e,
    children: o
  }
), f = D;
export {
  f as default
};
